/* Ampswirl 3D shaker for Shopify Dawn. Adds <amp-viewer>, [data-amp-mix] buttons, [data-amp-finish] swatches and colour-matched photos. */
(function(){
"use strict";
if(window.__amp3dLoaded)return;window.__amp3dLoaded=true;
function loadThree(){if(window.THREE)return Promise.resolve();return window.__ampThree||(window.__ampThree=new Promise(function(res,rej){var s=document.createElement("script");s.src="https://cdn.jsdelivr.net/npm/three@0.149.0/build/three.min.js";s.onload=res;s.onerror=rej;document.head.appendChild(s)}))}
function envMap(renderer){
  const pm=new THREE.PMREMGenerator(renderer), s=new THREE.Scene();
  s.background=new THREE.Color(0x221d17);
  const add=(w,h,p,c,k)=>{const m=new THREE.Mesh(new THREE.PlaneGeometry(w,h),new THREE.MeshBasicMaterial({color:new THREE.Color(c).multiplyScalar(k),side:THREE.DoubleSide}));m.position.set(...p);m.lookAt(0,0,0);s.add(m)};
  add(8,3,[0,7,3],0xfff2dc,3.2); add(2.4,9,[-6,1,2],0xffe2b8,2.6); add(2,9,[6,2,-1],0xffffff,1.8); add(12,1.2,[0,-5,4],0xc9a962,.9); add(3,6,[0,1,-7],0xffd9a0,1.2);
  const t=pm.fromScene(s,0.035).texture; pm.dispose(); return t;
}
function scaleTexture(){
  const c=document.createElement("canvas");c.width=512;c.height=1024;const g=c.getContext("2d");
  const Y=v=>1024*(0.965-(v/500)*0.88);
  g.strokeStyle="#D8BC7A";g.fillStyle="#D8BC7A";g.lineWidth=5;
  g.beginPath();g.moveTo(140,Y(100));g.lineTo(140,Y(500));g.stroke();
  g.font="500 50px sans-serif";g.textBaseline="middle";
  [100,200,300,400,500].forEach(v=>{g.beginPath();g.moveTo(140,Y(v));g.lineTo(250,Y(v));g.stroke();g.fillText(v+" ml",262,Y(v))});
  g.font="400 38px sans-serif";
  [[5,148],[9,266],[12,355],[15,444]].forEach(([o,ml])=>{g.beginPath();g.moveTo(140,Y(ml));g.lineTo(195,Y(ml));g.stroke();g.fillText(o+" oz",262,Y(ml))});
  const t=new THREE.CanvasTexture(c);t.encoding=THREE.sRGBEncoding;t.anisotropy=4;return t;
}
function buildShaker(){
  /* Shaker shaped after the product photo: tapered body with an arched front window,
     clear flared jar, tall lid band, flat flip-top with a side tab, wishbone whisk. */
  const G=new THREE.Group(), K=18.5;
  const M={
    body:new THREE.MeshPhysicalMaterial({color:0x131210,roughness:.6,metalness:.05,clearcoat:.35,clearcoatRoughness:.5,side:THREE.DoubleSide}),
    lid:new THREE.MeshPhysicalMaterial({color:0x0d0c0b,roughness:.45,metalness:.05,clearcoat:.5,clearcoatRoughness:.35,side:THREE.DoubleSide}),
    accent:new THREE.MeshStandardMaterial({color:0xC9A962,roughness:.26,metalness:1}),
    glass:new THREE.MeshPhysicalMaterial({color:0xffffff,roughness:.04,metalness:0,transparent:true,opacity:.16,clearcoat:1,side:THREE.DoubleSide,depthWrite:false,envMapIntensity:1.6}),
    blade:new THREE.MeshStandardMaterial({color:0xEDEBE6,roughness:.38,metalness:0}),
    steel:new THREE.MeshStandardMaterial({color:0xC8C8C6,roughness:.25,metalness:1}),
    bezel:new THREE.MeshPhysicalMaterial({color:0x1a1918,roughness:.28,metalness:.1,clearcoat:.8,clearcoatRoughness:.2}),
    liquid:new THREE.MeshPhysicalMaterial({color:0xC9A27A,roughness:.35,transparent:true,opacity:.82,side:THREE.DoubleSide,depthWrite:false}),
    glow:new THREE.MeshStandardMaterial({color:0xC9A962,emissive:0xC9A962,emissiveIntensity:0,roughness:.3,metalness:.8})
  };
  const lathe=(pts,m,seg=96)=>{const g=new THREE.LatheGeometry(pts.map(p=>new THREE.Vector2(p[0]*K,p[1]*K)),seg);const o=new THREE.Mesh(g,m);G.add(o);return o};
  const rB=.0395, rT=.044, hTop=.170, yWin=.056, wall=.0022;
  const rAt=y=>rB+(rT-rB)*y/hTop;
  const rad=Math.PI/180;
  const halfA=y=>{
    const rc=.016, a0=37*rad, a1=42*rad, yFl=.128, yEnd=hTop-.004;
    if(y<yWin)return 0;
    if(y<yWin+rc){const k=(y-yWin)/rc;return a0*Math.pow(Math.max(0,1-(1-k)*(1-k)),.4)}
    if(y<yFl)return a0+(a1-a0)*(y-yWin-rc)/(yFl-yWin-rc);
    let t=Math.min(1,(y-yFl)/(yEnd-yFl));t=t*t*(3-2*t);return a1+(84*rad-a1)*Math.pow(t,1.6);
  };
  /* solid lower body with rounded foot */
  lathe([[0,0],[rB-.004,0],[rB-.0012,.0008],[rB,.004],[rAt(yWin),yWin]],M.body,128);
  /* shell with the front window cut out, built row by row so the opening stays smooth */
  const SEG=128, ROWS=90, yE=hTop-.004, outer=[], inner=[];
  for(let i=0;i<=ROWS;i++){
    const y=yWin+(yE-yWin)*i/ROWS, a=halfA(y), r=rAt(y);
    for(let k=0;k<=SEG;k++){const th=a+(Math.PI*2-2*a)*k/SEG;
      outer.push(r*Math.sin(th)*K,y*K,r*Math.cos(th)*K);
      inner.push((r-wall)*Math.sin(th)*K,y*K,(r-wall)*Math.cos(th)*K)}
  }
  const gridIdx=(flip)=>{const I=[];for(let i=0;i<ROWS;i++)for(let k=0;k<SEG;k++){const a=i*(SEG+1)+k,b=a+1,c=a+SEG+1,d=c+1;
    if(flip)I.push(a,b,c,b,d,c);else I.push(a,c,b,b,c,d)}return I};
  const mesh=(P,I,m)=>{const g=new THREE.BufferGeometry();g.setAttribute("position",new THREE.Float32BufferAttribute(P,3));g.setIndex(I);g.computeVertexNormals();const o=new THREE.Mesh(g,m);G.add(o);return o};
  mesh(outer,gridIdx(false),M.body);
  mesh(inner,gridIdx(true),M.body);
  /* window edge faces joining outer and inner skins */
  const eP=[],eI=[];
  [0,SEG].forEach((k,s)=>{const st=eP.length/3;
    for(let i=0;i<=ROWS;i++){const o=(i*(SEG+1)+k)*3;eP.push(outer[o],outer[o+1],outer[o+2],inner[o],inner[o+1],inner[o+2])}
    for(let i=0;i<ROWS;i++){const a=st+2*i,b=a+1,c=a+2,d=a+3;if(s)eI.push(a,b,c,b,d,c);else eI.push(a,c,b,b,c,d)}});
  mesh(eP,eI,M.body);
  /* shoulder ring up to the lid */
  lathe([[rAt(yE),yE],[rT,hTop]],M.body,128);
  /* lid band with rounded top edge */
  lathe([[rT-.0003,hTop],[.0447,hTop+.0006],[.0451,.172],[.0451,.2005],[.0447,.204],[.0436,.2065],[.036,.2075],[0,.2075]],M.lid,128);
  /* thin seam between body and lid */
  const seam=new THREE.Mesh(new THREE.TorusGeometry(.04465*K,.0006*K,8,128),M.bezel);seam.rotation.x=Math.PI/2;seam.position.y=hTop*K;G.add(seam);
  /* flat flip-top cap with a soft bevel */
  const capS=new THREE.Shape(), cw=.084*K/2, ch=.082*K/2, cr=.036*K;
  capS.moveTo(-cw+cr,-ch);capS.lineTo(cw-cr,-ch);capS.quadraticCurveTo(cw,-ch,cw,-ch+cr);capS.lineTo(cw,ch-cr);capS.quadraticCurveTo(cw,ch,cw-cr,ch);
  capS.lineTo(-cw+cr,ch);capS.quadraticCurveTo(-cw,ch,-cw,ch-cr);capS.lineTo(-cw,-ch+cr);capS.quadraticCurveTo(-cw,-ch,-cw+cr,-ch);
  const capG=new THREE.ExtrudeGeometry(capS,{depth:.0045*K,bevelEnabled:true,bevelThickness:.0012*K,bevelSize:.0012*K,bevelSegments:3,curveSegments:24});
  capG.rotateX(-Math.PI/2);
  const cap=new THREE.Mesh(capG,M.lid);cap.position.set(-.001*K,(.2075+.0012)*K,0);cap.rotation.z=-2.5*rad;G.add(cap);
  /* shallow oval recess on the cap */
  const rec=new THREE.Mesh(new THREE.TorusGeometry(.028*K,.0007*K,8,96),M.bezel);rec.rotation.x=Math.PI/2;rec.scale.set(1,.85,1);rec.position.set(-.004*K,(.2075+.0072)*K,0);G.add(rec);
  /* side flip tab, angled up to the right */
  const tabS=new THREE.Shape();
  tabS.moveTo(0,-.016*K);tabS.lineTo(.030*K,-.0145*K);
  for(let i=0;i<=16;i++){const t=-Math.PI/2+Math.PI*i/16;tabS.lineTo((.034+.0135*Math.cos(t))*K,.0135*Math.sin(t)*K)}
  tabS.lineTo(.030*K,.0145*K);tabS.lineTo(0,.016*K);tabS.lineTo(0,-.016*K);
  const tabG=new THREE.ExtrudeGeometry(tabS,{depth:.0055*K,bevelEnabled:true,bevelThickness:.0009*K,bevelSize:.0009*K,bevelSegments:3,curveSegments:16});
  tabG.rotateX(-Math.PI/2);
  const tab=new THREE.Mesh(tabG,M.lid);tab.position.set(.026*K,.2072*K,0);tab.rotation.z=9*rad;G.add(tab);
  /* the theme animates S.hinge; this cap stays closed like the product photo */
  const hinge=new THREE.Group();
  /* clear jar with flared rim */
  const jarO=[[0,.060],[.0318,.060],[.0330,.0612],[.0355,.147],[.0392,.159],[.0432,.168],[.0432,.173]];
  const cup=lathe(jarO,M.glass);cup.renderOrder=3;
  const jarI=lathe(jarO.map(([r,y])=>[Math.max(0,r-.0016),y<.061?y+.0016:y]),M.glass);jarI.renderOrder=3;
  /* liquid */
  const floor=.0616*K, level=2.32, lr=.0318*K;
  const side=new THREE.Mesh(new THREE.CylinderGeometry(lr,lr*.97,level-floor,64,1,true),M.liquid);side.position.y=(level+floor)/2;side.renderOrder=1;G.add(side);
  const RINGS=18,SEG2=64,pos=[],idx=[];
  for(let i=0;i<=RINGS;i++)for(let j=0;j<=SEG2;j++){const r=i/RINGS*lr,a=j/SEG2*Math.PI*2;pos.push(Math.cos(a)*r,0,Math.sin(a)*r)}
  for(let i=0;i<RINGS;i++)for(let j=0;j<SEG2;j++){const a=i*(SEG2+1)+j,b=a+SEG2+1;idx.push(a,b,a+1,b,b+1,a+1)}
  const sg=new THREE.BufferGeometry();sg.setAttribute("position",new THREE.Float32BufferAttribute(pos,3));sg.setIndex(idx);sg.computeVertexNormals();
  const surf=new THREE.Mesh(sg,M.liquid);surf.position.y=level;surf.renderOrder=2;G.add(surf);
  const base0=Float32Array.from(pos);
  const N=140,fp=new Float32Array(N*3),fd=[];
  for(let i=0;i<N;i++){fd.push({r:.08+Math.random()*(lr-.14),a:Math.random()*6.28,y:floor+.06+Math.random()*(level-floor-.12)})}
  const fg=new THREE.BufferGeometry();fg.setAttribute("position",new THREE.BufferAttribute(fp,3));
  const flecks=new THREE.Points(fg,new THREE.PointsMaterial({color:0xF3E6CC,size:.035,transparent:true,opacity:.9,depthWrite:false}));G.add(flecks);
  /* steel drive plate + white wishbone whisk */
  const blade=new THREE.Group();blade.position.y=floor;G.add(blade);
  const plate=new THREE.Mesh(new THREE.CylinderGeometry(.24,.25,.045,40),M.steel);plate.position.y=.022;blade.add(plate);
  const shaft=new THREE.Mesh(new THREE.CylinderGeometry(.03,.03,.98,12),M.blade);shaft.position.y=.5;blade.add(shaft);
  const tip=new THREE.Mesh(new THREE.SphereGeometry(.045,16,12),M.blade);tip.position.y=1.0;blade.add(tip);
  [0,Math.PI/2].forEach(rot=>{[-1,1].forEach(sg2=>{
    const pts=[];for(let i=0;i<=24;i++){const t=i/24;pts.push(new THREE.Vector3(sg2*.0205*K*Math.sin(t*Math.PI*.62),(.108-.042*Math.pow(t,1.5))*K-floor,0))}
    const arm=new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts),40,.026,8,false),M.blade);arm.rotation.y=rot;blade.add(arm)})});
  /* power button on the front of the base */
  const bY=.027*K, btnZ=rAt(.027)*K;
  const btn=new THREE.Mesh(new THREE.CylinderGeometry(.15,.15,.03,40),M.bezel);btn.rotation.x=Math.PI/2;btn.position.set(0,bY,btnZ);G.add(btn);
  const ring=new THREE.Mesh(new THREE.TorusGeometry(.085,.012,10,40,Math.PI*1.7),M.glow);ring.position.set(0,bY,btnZ+.018);ring.rotation.z=Math.PI/2+Math.PI*.15;G.add(ring);
  const tick=new THREE.Mesh(new THREE.BoxGeometry(.022,.08,.01),M.glow);tick.position.set(0,bY+.05,btnZ+.02);G.add(tick);
  const halo=new THREE.Mesh(new THREE.TorusGeometry(.125,.005,8,48),M.glow);halo.position.set(0,bY,btnZ+.017);G.add(halo);
  const hit=new THREE.Mesh(new THREE.CylinderGeometry(.26,.26,.12,24),new THREE.MeshBasicMaterial({visible:false}));hit.rotation.x=Math.PI/2;hit.position.set(0,bY,btnZ+.03);G.add(hit);
  G.position.y=-1.98;
  return {G,M,blade,surf,base0,flecks,fd,fp,hinge,level,lr,power:[btn,ring,tick,hit]};
}
function createViewer(host,opts){
  const scrollSpin=!!opts.scrollSpin;
  const FINISHES={dark:{body:opts.dark,accent:opts.accent,lidK:.75,bodyRough:.6,bodyMetal:.05},light:{body:opts.light,accent:opts.accent,lidK:.92,bodyRough:.55,bodyMetal:0}};
  let finish=opts.finish==='light'?'light':'dark';
  let alive=true;
  let renderer;
  try{renderer=new THREE.WebGLRenderer({antialias:true,alpha:true})}catch(e){return null}
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  renderer.outputEncoding=THREE.sRGBEncoding;renderer.toneMapping=THREE.ACESFilmicToneMapping;renderer.toneMappingExposure=1.05;
  host.prepend(renderer.domElement);
  const scene=new THREE.Scene();scene.environment=envMap(renderer);
  const cam=new THREE.PerspectiveCamera(28,1,.1,100);cam.position.set(0,.7,10.2);cam.lookAt(0,-.05,0);
  const key=new THREE.DirectionalLight(0xfff1dc,1.4);key.position.set(4,6,6);scene.add(key);
  const rim=new THREE.DirectionalLight(0xd9b56e,1.6);rim.position.set(-5,3,-4);scene.add(rim);
  scene.add(new THREE.HemisphereLight(0xfff6e8,0x2a2017,.35));
  const S=buildShaker();const pivot=new THREE.Group();pivot.add(S.G);scene.add(pivot);
  const st={rotY:-.5,velY:0,tilt:0,drag:false,lx:0,mix:0,mixTarget:0,mixUntil:0,visible:true,cap:-1.15,capTarget:-1.15,t:0};
  const reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
  const cv=renderer.domElement;
  const ray=new THREE.Raycaster(),ndc=new THREE.Vector2();
  const onPower=e=>{const r=cv.getBoundingClientRect();ndc.set(((e.clientX-r.left)/r.width)*2-1,-((e.clientY-r.top)/r.height)*2+1);ray.setFromCamera(ndc,cam);return ray.intersectObjects(S.power,false).length>0};
  let down=null;
  cv.addEventListener("pointerdown",e=>{st.drag=true;st.lx=e.clientX;st.velY=0;down={x:e.clientX,y:e.clientY};cv.setPointerCapture(e.pointerId)});
  cv.addEventListener("pointermove",e=>{if(!st.drag){cv.style.cursor=onPower(e)?"pointer":"grab";return}const dx=e.clientX-st.lx;st.lx=e.clientX;st.rotY+=dx*.01;st.velY=dx*.01});
  cv.addEventListener("pointerup",e=>{st.drag=false;if(down&&Math.hypot(e.clientX-down.x,e.clientY-down.y)<8&&onPower(e)){st.velY=0;toggle()}down=null});
  cv.addEventListener("pointercancel",()=>{st.drag=false;down=null});
  const fit=()=>{const w=host.clientWidth,h=host.clientHeight;if(!w||!h)return;renderer.setSize(w,h,false);cam.aspect=w/h;
    cam.position.z=w/h<.8?10.2*Math.pow(.8/(w/h),.9):10.2;cam.updateProjectionMatrix()};
  fit();
  new IntersectionObserver(es=>{st.visible=es[0].isIntersecting}).observe(host);
  const target={body:new THREE.Color(),accent:new THREE.Color(),lid:new THREE.Color(),rough:.6,metal:0};
  const setFinish=k=>{const f=FINISHES[k];target.body.set(f.body);target.accent.set(f.accent);target.lid.set(f.body).multiplyScalar(f.lidK);target.rough=f.bodyRough;target.metal=f.bodyMetal};
  setFinish(finish);S.M.body.color.copy(target.body);S.M.accent.color.copy(target.accent);S.M.lid.color.copy(target.lid);
  const mix=(sec=3.2)=>{st.mixTarget=1;st.mixUntil=performance.now()+sec*1000;st.capTarget=0};
  const toggle=()=>{if(st.mixTarget===1){st.mixUntil=0}else mix(6)};
  let last=performance.now();
  function frame(now){
    if(!alive)return;requestAnimationFrame(frame);
    const dt=Math.min(.05,(now-last)/1000);last=now;
    if(!st.visible||document.hidden)return;
    st.t+=dt;
    if(now>st.mixUntil&&st.mixTarget===1){st.mixTarget=0;st.capTarget=-1.15}
    st.mix+=(st.mixTarget-st.mix)*Math.min(1,dt*(st.mixTarget?3:1.6));
    if(!st.drag){st.velY*=.94;st.rotY+=st.velY;if(!reduce&&Math.abs(st.velY)<.002)st.rotY+=dt*.28}
    const sc=scrollSpin?Math.min(scrollY,900)*.0025:0;
    pivot.rotation.y=st.rotY+sc;
    pivot.rotation.x=.08+Math.sin(st.t*.6)*.02;
    pivot.position.y=reduce?0:Math.sin(st.t*1.1)*.05;
    st.cap+=(st.capTarget-st.cap)*Math.min(1,dt*4);S.hinge.rotation.x=st.cap;
    const k=Math.min(1,dt*5);
    S.M.body.color.lerp(target.body,k);S.M.accent.color.lerp(target.accent,k);S.M.lid.color.lerp(target.lid,k);
    S.M.body.roughness+=(target.rough-S.M.body.roughness)*k;S.M.body.metalness+=(target.metal-S.M.body.metalness)*k;
    S.M.glow.emissiveIntensity=Math.max(st.mix*1.4,reduce?.35:.3+.3*Math.sin(st.t*3));S.M.glow.color.copy(S.M.accent.color);S.M.glow.emissive.copy(S.M.accent.color);
    S.blade.rotation.y+=dt*(.4+st.mix*38);
    const p=S.surf.geometry.attributes.position,b=S.base0,depth=.42*st.mix;
    for(let i=0;i<p.count;i++){const x=b[i*3],z=b[i*3+2],r2=(x*x+z*z)/(S.lr*S.lr);
      p.array[i*3+1]=-depth*Math.exp(-r2*4.2)+depth*.22*r2+Math.sin(Math.atan2(z,x)*3+st.t*8)*.012*st.mix*r2}
    p.needsUpdate=true;S.surf.geometry.computeVertexNormals();S.surf.rotation.y+=dt*st.mix*6;
    for(let i=0;i<S.fd.length;i++){const d=S.fd[i];d.a+=dt*(.15+st.mix*7/(d.r+.25));
      const yy=d.y+Math.sin(d.a*2+i)*.05*st.mix;
      S.fp[i*3]=Math.cos(d.a)*d.r;S.fp[i*3+1]=Math.min(yy,S.level-.02-depth*Math.exp(-(d.r*d.r)/(S.lr*S.lr)*4.2));S.fp[i*3+2]=Math.sin(d.a)*d.r}
    S.flecks.geometry.attributes.position.needsUpdate=true;
    renderer.render(scene,cam);
  }
  requestAnimationFrame(frame);
  const ro=new ResizeObserver(fit);ro.observe(host);
  return {setFinish:k=>setFinish(k==='light'?'light':'dark'),mix,toggle,canvas:cv,dispose(){alive=false;ro.disconnect();renderer.dispose();cv.remove()}};
}

class AmpViewer extends HTMLElement{
  connectedCallback(){
    if(this._started)return;this._started=true;
    var d=this.dataset,self=this;
    this._onFinish=function(e){if(self._v&&e.detail&&e.detail.finish)self._v.setFinish(e.detail.finish)};
    document.addEventListener("amp:finish",this._onFinish);
    loadThree().then(function(){
      if(!self.isConnected)return;
      var v=null;try{v=createViewer(self,{dark:d.dark||"#141312",light:d.light||"#DDCDB2",accent:d.accent||"#C9A962",finish:d.finish||"dark",scrollSpin:d.scrollSpin==="true"})}catch(err){v=null}
      if(v)self._v=v;else self.classList.add("amp-no3d");
    }).catch(function(){self.classList.add("amp-no3d")});
  }
  disconnectedCallback(){document.removeEventListener("amp:finish",this._onFinish);if(this._v){this._v.dispose();this._v=null}this._started=false}
  mix(){if(this._v)this._v.mix()}
  toggle(){if(this._v)this._v.toggle()}
}
if(!customElements.get("amp-viewer"))customElements.define("amp-viewer",AmpViewer);

function finishFor(text,key){return key&&String(text||"").toLowerCase().indexOf(key)>-1?"light":"dark"}
function applyFinish(detail){
  document.querySelectorAll("[data-amp-finish]").forEach(function(b){b.setAttribute("aria-pressed",String(b.dataset.label?b.dataset.label===detail.label:b.dataset.ampFinish===detail.finish))});
  if(detail.label)document.querySelectorAll("[data-amp-finish-label]").forEach(function(l){l.textContent=detail.label});
  document.querySelectorAll("[data-amp-color]").forEach(function(el){var c=el.dataset.ampColor;el.hidden=c!=="both"&&c!==detail.finish});
}
document.addEventListener("amp:finish",function(e){applyFinish(e.detail||{})});
document.addEventListener("click",function(e){
  var m=e.target.closest("[data-amp-mix]");
  if(m){var sec=m.closest(".shopify-section")||document;var v=sec.querySelector("amp-viewer")||document.querySelector("amp-viewer");if(v)v.mix()}
  var sw=e.target.closest("[data-amp-finish]");
  if(sw){document.dispatchEvent(new CustomEvent("amp:finish",{detail:{finish:sw.dataset.ampFinish,label:sw.dataset.label}}))}
  var g=e.target.closest("[data-amp-gal]");
  if(g){var track=(g.closest(".shopify-section")||document).querySelector(".amp-gal");if(track)track.scrollBy({left:(g.dataset.ampGal==="next"?1:-1)*track.clientWidth*.8,behavior:"smooth"})}
});
function syncFromPicker(){
  var v=document.querySelector("amp-viewer[data-light-key]");if(!v)return;
  var picks=[].map.call(document.querySelectorAll("variant-selects input:checked, variant-selects select, variant-radios input:checked, variant-radios select"),function(x){return x.value}).join(" ");
  if(!picks)return;
  document.dispatchEvent(new CustomEvent("amp:finish",{detail:{finish:finishFor(picks,v.dataset.lightKey),label:picks}}));
}
document.addEventListener("change",function(e){if(e.target.closest("variant-selects, variant-radios"))setTimeout(syncFromPicker,30)});
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",syncFromPicker);else syncFromPicker();
document.addEventListener("shopify:section:load",syncFromPicker);
window.AmpFinishFor=finishFor;
})();
